import React, { useState } from 'react';
import { colors, radius, transitions } from '../../theme';

const variants = {
  primary: {
    background: `linear-gradient(135deg, ${colors.gold}, ${colors.goldPressed})`,
    color: '#0A0E13',
    border: 'none',
  },
  secondary: {
    background: 'transparent',
    color: colors.text,
    border: `1px solid ${colors.borderStrong}`,
  },
  tertiary: {
    background: 'transparent',
    color: colors.textMuted,
    border: 'none',
  },
};

/**
 * Primary/secondary/tertiary button hierarchy with the item-16 press-scale
 * micro-interaction (0.98x on press, released on up/leave).
 */
const CipherButton = ({ variant = 'primary', disabled, children, style, ...props }) => {
  const [pressed, setPressed] = useState(false);
  const base = variants[variant] || variants.primary;
  const isCompact = variant === 'tertiary';

  return (
    <button
      {...props}
      disabled={disabled}
      onPointerDown={(e) => { setPressed(true); props.onPointerDown?.(e); }}
      onPointerUp={(e) => { setPressed(false); props.onPointerUp?.(e); }}
      onPointerLeave={(e) => { setPressed(false); props.onPointerLeave?.(e); }}
      style={{
        ...base,
        width: isCompact ? 'auto' : '100%',
        padding: isCompact ? '4px 0' : '16px',
        borderRadius: isCompact ? 0 : radius.sm,
        fontSize: isCompact ? '13.5px' : '16px',
        fontWeight: isCompact ? 600 : 700,
        cursor: disabled ? 'not-allowed' : 'pointer',
        opacity: disabled ? 0.5 : 1,
        transform: pressed && !disabled ? 'scale(0.98)' : 'scale(1)',
        transition: transitions.buttonPress,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        gap: '10px',
        WebkitTapHighlightColor: 'transparent',
        ...style,
      }}
    >
      {children}
    </button>
  );
};

export default CipherButton;
